import type { IRegion, IState } from './types/static'

export const SITE_TITLE = 'Cursos Online para Concursos'
export const SITE_DESCRIPTION =
  'Preparação para concursos. GARANTIA INFINITA! PDF + Videoaulas. Pague em até 12x! Baixe aulas para Receita Federal, INSS, PCDF, Tribunais. Material 100% focado no edital.'
export const SUBSCRIPTION = 'https://assinaturas.direcaoconcursos.com.br/'
export const STUDENT_AREA_URL = import.meta.env?.PUBLIC_STUDENT_AREA_URL
export const POSTHOG_CLIENT =
  import.meta.env?.PUBLIC_POSTHOG_API_KEY ||
  'phc_67sf6QGYHir1kiABQ9tFpd8R0DMjvWGtG00SpGcbPl9'

export const PUBLIC_LOCAL_STORAGE_VERSION = 1

export const PUBLIC_RECAPTCHA_SITE_KEY = import.meta.env
  ?.PUBLIC_RECAPTCHA_SITE_KEY
export const RECAPTCHA_SECRET_KEY = import.meta.env?.RECAPTCHA_SECRET_KEY

export const REVALIDATION_PATTERN = {
  /** @returns (60) = 60 seconds*/
  DEFAULT: 60,
  /** @returns (0) = 0 seconds*/
  REALTIME: 0,
  /** @returns (30) = 30 seconds */
  THIRD_SECONDS: 30,

  /** @returns (60) = 60 seconds */
  ONE_MINUTE_IN_SECONDS: 60,
  /** @returns (60 * 3) = 180 seconds */
  THREE_MINUTES_IN_SECONDS: 60 * 3,
  /** @returns (60 * 5) = 300 seconds */
  FIVE_MINUTES_IN_SECONDS: 60 * 5,
  /** @returns (60 * 10) = 600 seconds */
  TEN_MINUTES_IN_SECONDS: 60 * 10,
  /** @returns (60 * 15) = 900 seconds */
  FIFTEEN_MINUTES_IN_SECONDS: 60 * 15,
  /** @returns (60 * 30) = 1.800 seconds */
  THIRD_MINUTES_IN_SECONDS: 60 * 30,

  /** @returns (60 * 60) = 3.600 seconds */
  ONE_HOUR_IN_SECONDS: 60 * 60,
  /** @returns (60 * 60 * 6) = 21.600 seconds */
  SIX_HOURS_IN_SECONDS: 60 * 60 * 6,
  /** @returns (60 * 60 * 12) = 432.00 seconds */
  TWELVE_HOURS_IN_SECONDS: 60 * 60 * 12,

  /** @returns (60 * 60 * 24) = 86.400 seconds */
  ONE_DAY_IN_SECONDS: 60 * 60 * 24,
  /** @returns (60 * 60 * 24 * 5) = 432.000 seconds */
  FIVE_DAYS_IN_SECONDS: 60 * 60 * 24 * 5,
  /** @returns (60 * 60 * 24 * 10) = 864.000 seconds */
  TEN_DAYS_IN_SECONDS: 60 * 60 * 24 * 10,
  /** @returns (60 * 60 * 24 * 15) = 1.296.000 seconds */
  FIFTEEN_DAYS_IN_SECONDS: 60 * 60 * 24 * 15,

  /** @returns (60 * 60 * 24 * 30) = 2.592.000 seconds */
  ONE_MONTH_IN_SECONDS: 60 * 60 * 24 * 30,
  /** @returns (60 * 60 * 24 * 30 * 6) = 15.552.000 seconds */
  SIX_MONTH_IN_SECONDS: 60 * 60 * 24 * 30 * 6,
  /** @returns (60 * 60 * 24 * 365) = 31.536.000 seconds */
  ONE_YEAR_IN_SECONDS: 60 * 60 * 24 * 365,
}

export const CACHE_CONTROL = {
  /** @returns public, s-maxage=0, max-age=0, must-revalidate */
  REALTIME: `public, s-maxage=${REVALIDATION_PATTERN.REALTIME}, max-age=${REVALIDATION_PATTERN.REALTIME}, must-revalidate`,

  /** @returns public, s-maxage=60, max-age=60, must-revalidate */
  ONE_MINUTE: `public, s-maxage=${REVALIDATION_PATTERN.ONE_MINUTE_IN_SECONDS}, max-age=${REVALIDATION_PATTERN.ONE_MINUTE_IN_SECONDS}, must-revalidate`,

  /** @returns public, s-maxage=300, max-age=300, stale-while-revalidate=60 */
  FIVE_MINUTES: `public, s-maxage=${REVALIDATION_PATTERN.FIVE_MINUTES_IN_SECONDS}, max-age=${REVALIDATION_PATTERN.FIVE_MINUTES_IN_SECONDS}, stale-while-revalidate=${REVALIDATION_PATTERN.ONE_MINUTE_IN_SECONDS}`,

  /** @returns public, s-maxage=180, max-age=180, stale-while-revalidate=60 */
  THREE_MINUTES: `public, s-maxage=${REVALIDATION_PATTERN.THREE_MINUTES_IN_SECONDS}, max-age=${REVALIDATION_PATTERN.THREE_MINUTES_IN_SECONDS}, stale-while-revalidate=${REVALIDATION_PATTERN.ONE_MINUTE_IN_SECONDS}`,

  /** @returns public, s-maxage=600, max-age=600, stale-while-revalidate=60 */
  TEN_MINUTES: `public, s-maxage=${REVALIDATION_PATTERN.TEN_MINUTES_IN_SECONDS}, max-age=${REVALIDATION_PATTERN.TEN_MINUTES_IN_SECONDS}, stale-while-revalidate=${REVALIDATION_PATTERN.ONE_MINUTE_IN_SECONDS}`,

  /** @returns public, s-maxage=900, max-age=900, stale-while-revalidate=60 */
  ONE_DAY: `public, s-maxage=${REVALIDATION_PATTERN.ONE_DAY_IN_SECONDS}, max-age=${REVALIDATION_PATTERN.ONE_DAY_IN_SECONDS}, stale-while-revalidate=${REVALIDATION_PATTERN.ONE_MINUTE_IN_SECONDS}`,

  /** @returns public, s-maxage=432000, max-age=432000, stale-while-revalidate=60 */
  FIVE_DAYS: `public, s-maxage=${REVALIDATION_PATTERN.FIVE_DAYS_IN_SECONDS}, max-age=${REVALIDATION_PATTERN.FIVE_DAYS_IN_SECONDS}, stale-while-revalidate=${REVALIDATION_PATTERN.ONE_MINUTE_IN_SECONDS}`,
}

export enum TAG {
  HIGHLIGHT_L0 = '91477',
  HIGHLIGHT_L1 = '87680',
  HIGHLIGHT_L2 = '87681',
  AC = '87536',
  AL = '87539',
  AM = '82528',
  AP = '87542',
  BA = '87530',
  CE = '87534',
  DF = '223',
  ES = '87527',
  GO = '87528',
  MA = '87550',
  MG = '86005',
  MT = '87543',
  MS = '87565',
  PA = '63188',
  PB = '87560',
  PE = '87547',
  PI = '73359',
  PR = '87540',
  RJ = '47684',
  RN = '62790',
  RO = '87535',
  RR = '80847',
  RS = '87548',
  SC = '87532',
  SE = '87613',
  SP = '1039',
  TO = '59481',
  CONCURSO_PUBLICO = '1471',
  CONCURSOS_PÚBLICOS = '9',
  DIRECAOCONCURSOS = '90268',
}

export const getAreas = () => {
  const areas: Array<{ value: string; label: string }> = [
    { value: '0', label: 'Todas carreiras' },
    { value: '1', label: 'Fiscal' },
    { value: '2', label: 'Policial' },
    { value: '3', label: 'Tribunal' },
    { value: '4', label: 'Controle' },
    { value: '5', label: 'Administrativa' },
    { value: '6', label: 'Legislativa' },
    { value: '7', label: 'Financeira' },
    { value: '8', label: 'Agências Reguladoras' },
    { value: '9', label: 'Bancária' },
    { value: '10', label: 'Militar' },
    { value: '11', label: 'Educacional' },
    { value: '12', label: 'Saúde' },
    { value: '13', label: 'TI' },
    { value: '14', label: 'Outra' },
  ]
  return areas
}

export const getStatesAndRegions = ({ current }: { current?: string }) => {
  try {
    const states: Array<IState> = [
      {
        tag: TAG.AC,
        abbreviation: 'AC',
        display: 'Acre',
        label: 'Acre',
        value: 'acre',
        region: 'norte',
      },
      {
        tag: TAG.AL,
        abbreviation: 'AL',
        display: 'Alagoas',
        label: 'Alagoas',
        value: 'alagoas',
        region: 'nordeste',
      },
      {
        tag: TAG.AM,
        abbreviation: 'AM',
        display: 'Amazonas',
        label: 'Amazonas',
        value: 'amazonas',
        region: 'norte',
      },
      {
        tag: TAG.AP,
        abbreviation: 'AP',
        display: 'Amapá',
        label: 'Amapá',
        value: 'amapa',
        region: 'norte',
      },
      {
        tag: TAG.BA,
        abbreviation: 'BA',
        display: 'Bahia',
        label: 'Bahia',
        value: 'bahia',
        region: 'nordeste',
      },
      {
        tag: TAG.CE,
        abbreviation: 'CE',
        display: 'Ceará',
        label: 'Ceará',
        value: 'ceara',
        region: 'nordeste',
      },
      {
        tag: TAG.DF,
        abbreviation: 'DF',
        display: 'Distrito Federal',
        label: 'Distrito Federal',
        value: 'distrito-federal',
        region: 'centro-oeste',
      },
      {
        tag: TAG.ES,
        abbreviation: 'ES',
        display: 'Espírito Santo',
        label: 'Espírito Santo',
        value: 'espirito-santo',
        region: 'sudeste',
      },
      {
        tag: TAG.GO,
        abbreviation: 'GO',
        display: 'Goiás',
        label: 'Goiás',
        value: 'goias',
        region: 'centro-oeste',
      },
      {
        tag: TAG.MA,
        abbreviation: 'MA',
        display: 'Maranhão',
        label: 'Maranhão',
        value: 'maranhao',
        region: 'nordeste',
      },
      {
        tag: TAG.MG,
        abbreviation: 'MG',
        display: 'Minas Gerais',
        label: 'Minas Gerais',
        value: 'minas-gerais',
        region: 'sudeste',
      },
      {
        tag: TAG.MT,
        abbreviation: 'MT',
        display: 'Mato Grosso',
        label: 'Mato Grosso',
        value: 'mato-grosso',
        region: 'centro-oeste',
      },
      {
        tag: TAG.MS,
        abbreviation: 'MS',
        display: 'Mato Grosso do Sul',
        label: 'Mato Grosso do Sul',
        value: 'mato-grosso-do-sul',
        region: 'centro-oeste',
      },
      {
        tag: TAG.PA,
        abbreviation: 'PA',
        display: 'Pará',
        label: 'Pará',
        value: 'para',
        region: 'norte',
      },
      {
        tag: TAG.PB,
        abbreviation: 'PB',
        display: 'Paraiba',
        label: 'Paraiba',
        value: 'paraiba',
        region: 'nordeste',
      },
      {
        tag: TAG.PE,
        abbreviation: 'PE',
        display: 'Pernambuco',
        label: 'Pernambuco',
        value: 'pernambuco',
        region: 'nordeste',
      },
      {
        tag: TAG.PI,
        abbreviation: 'PI',
        display: 'Piauí',
        label: 'Piauí',
        value: 'piaui',
        region: 'nordeste',
      },
      {
        tag: TAG.PR,
        abbreviation: 'PR',
        display: 'Paraná',
        label: 'Paraná',
        value: 'parana',
        region: 'sul',
      },
      {
        tag: TAG.RJ,
        abbreviation: 'RJ',
        display: 'Rio de Janeiro',
        label: 'Rio de Janeiro',
        value: 'rio-de-janeiro',
        region: 'sudeste',
      },
      {
        tag: TAG.RN,
        abbreviation: 'RN',
        display: 'Rio Grande do Norte',
        label: 'Rio Grande do Norte',
        value: 'rio-grande-do-norte',
        region: 'nordeste',
      },
      {
        tag: TAG.RO,
        abbreviation: 'RO',
        display: 'Rondônia',
        label: 'Rondônia',
        value: 'rondonia',
        region: 'norte',
      },
      {
        tag: TAG.RR,
        abbreviation: 'RR',
        display: 'Roraima',
        label: 'Roraima',
        value: 'roraima',
        region: 'norte',
      },
      {
        tag: TAG.RS,
        abbreviation: 'RS',
        display: 'Rio Grande do Sul',
        label: 'Rio Grande do Sul',
        value: 'rio-grande-do-sul',
        region: 'sul',
      },
      {
        tag: TAG.SC,
        abbreviation: 'SC',
        display: 'Santa Catarina',
        label: 'Santa Catarina',
        value: 'santa-catarina',
        region: 'sul',
      },
      {
        tag: TAG.SE,
        abbreviation: 'SE',
        display: 'Sergipe',
        label: 'Sergipe',
        value: 'sergipe',
        region: 'nordeste',
      },
      {
        tag: TAG.SP,
        abbreviation: 'SP',
        display: 'São Paulo',
        label: 'São Paulo',
        value: 'sao-paulo',
        region: 'sudeste',
      },
      {
        tag: TAG.TO,
        abbreviation: 'TO',
        display: 'Tocantins',
        label: 'Tocantins',
        value: 'tocantins',
        region: 'norte',
      },
    ].map((s) => ({
      ...s,
      selected:
        s.value === current || s.region === current || current === 'nacional',
    }))

    const regions: Array<IRegion> = [
      { display: 'Nacionais', label: 'Nacional', value: 'nacional' },
      {
        display: 'Centro-Oeste',
        label: 'Centro-Oeste',
        value: 'centro-oeste',
      },
      {
        display: 'Nordeste',
        label: 'Nordeste',
        value: 'nordeste',
      },
      { display: 'Norte', label: 'Norte', value: 'norte' },
      {
        display: 'Sudeste',
        label: 'Sudeste',
        value: 'sudeste',
      },
      { display: 'Sul', label: 'Sul', value: 'sul' },
    ].map((r) => ({
      ...r,
      states: states.filter((s) => s.region === r.value).map((s) => s.value),
      selected: r.value === current,
    }))

    return { regions, states }
  } catch (_err) {
    return { regions: [], states: [] }
  }
}

export const getFormations = () => {
  try {
    const formations = [
      {
        value: '1',
        label: 'Ensino Fundamental',
      },
      {
        value: '2',
        label: 'Ensino Médio',
      },
      {
        value: '3',
        label: 'Ensino Superior',
      },
    ]

    return { formations }
  } catch (_err) {
    return { formations: [] }
  }
}

export const PROFILE_TOKEN = 'DC_PROFILE_TOKEN'
export const ACCESS_TOKEN = 'DC_ACCESS_TOKEN'
export const REFRESH_TOKEN = 'DC_REFRESH_TOKEN'
export const COOKIES_OPTIONS = {
  httpOnly: true,
  secure: true,
  path: '/',
  maxAge: REVALIDATION_PATTERN.TEN_DAYS_IN_SECONDS,
}

export const PROTECTED_ROUTES = ['/checkout', '/checkout-summary']

export const POSTHOG_FEATURE_FLAG = {
  checkout: [
    'checkout-body-layout',
    'checkout-header-layout',
    'checkout-spotlight-upsell',
  ],
}

export const SUBSCRIPTION_ICON = {
  AssinaturaVitalícia: '/images/assinatura-vitalicia.png',
  AssinaturaVitalíciaPremium: '/images/assinatura-vitalicia-premium.png',
  AssinaturaEssencial: '/images/assinatura-essencial.png',
  AssinaturaOuro: '/images/assinatura-ouro.png',
  AssinaturaDegustação: '/images/assinatura-degustacao.png',
}

export const SUBSCRIPTION_ID = {
  AssinaturaVitalícia: '638023241732d527cbdc1ccd',
  AssinaturaVitalíciaPremium: '65cf723ec3a23700355f014d',
}

export const FREQUENTLY_ASKED_QUESTIONS = [
  {
    icon: 'BookOpenCheck',
    category: 'content',
    question:
      'O material do Direção Concursos é suficiente para a minha preparação?',
    answer:
      'Sim. Nossos professores são especialistas em suas disciplinas e criam os cursos de acordo com o que é exigido no edital, levando em consideração as particularidades da banca examinadora. Nas aulas em PDF, você terá acesso a uma teoria completa e questões comentadas. Além disso, também oferecemos aulas em vídeo. Se não tivermos o curso específico para o concurso que você deseja, você pode começar seus estudos utilizando as disciplinas comuns a todos os concursos públicos, por meio dos nossos cursos regulares. E o melhor de tudo é que você não precisa sair de casa. Em qualquer lugar, com acesso à internet, você pode acessar o conteúdo. Nós já estivemos na mesma situação e sabemos exatamente como as provas costumam ser elaboradas. Recomendamos que você esclareça todas as suas dúvidas antes de fazer a compra.',
  },
  {
    icon: 'CloudDownload',
    category: 'platform',
    question: 'É possível fazer download do material?',
    answer:
      'Claro, você pode fazer o download do material. Você tem a opção de baixar o PDF da aula ou apenas o capítulo que está estudando, assim você pode estudar mesmo sem internet. É importante ressaltar que não é possível baixar tudo de uma vez.',
  },
  {
    icon: 'MessageCircleQuestion',
    category: 'platform',
    question:
      'Posso tirar minhas dúvidas com os professores? Qual o prazo de resposta?',
    answer:
      'Claro! Nossos professores ficarão felizes em ajudar a esclarecer todas as suas dúvidas o mais rápido possível. Se você tiver dificuldade em entender um exercício no PDF ou a teoria abordada nas videoaulas, poderá perguntar diretamente ao professor através do Fórum de Dúvidas na página da disciplina correspondente.Basta selecionar o trecho do Livro Digital em que você está com dúvida e escrever para enviá-la. O prazo de resposta é de até 5 dias úteis e você será notificado através da plataforma.',
  },
  {
    icon: 'PackageSearch',
    category: 'content',
    question: 'O que está incluído no meu curso?',
    answer:
      'No seu curso, você terá acesso a materiais em PDF e/ou aulas em vídeo que podem ser baixados para o seu smartphone, computador, tablet ou qualquer dispositivo de armazenamento. Além disso, você poderá enviar suas dúvidas sobre o conteúdo teórico e as questões do material para o professor.',
  },
  {
    icon: 'CreditCard',
    category: 'payment',
    question: 'Quais as formas de pagamento?',
    answer:
      'As formas de pagamento disponíveis são o boleto bancário, o cartão de crédito e o PIX. Infelizmente, no boleto não é possível parcelar, o pagamento deve ser feito de uma só vez e o prazo de compensação é de até 3 dias úteis (mas fique tranquilo, geralmente ocorre antes desse prazo). Já no cartão de crédito, é possível dividir em até 12 vezes, sendo que cada parcela mínima deve ter o valor de R$ 40,00 (quarenta reais). Assim que o pagamento for confirmado, a liberação do curso ocorre em alguns instantes. É importante ressaltar que é necessário ter o valor total do curso como limite disponível em seu cartão. Para pagamento via PIX, será gerado um código que deve ser utilizado dentro do prazo de 10 minutos. A liberação do curso será feita automaticamente assim que o pagamento for processado. Além disso, é válido mencionar que pagamentos realizados à vista, seja no boleto, PIX ou cartão de crédito, possuem descontos especiais.',
  },
  {
    icon: 'Shapes',
    category: 'subscription',
    question: 'Qual a diferença entre as assinaturas?',
    answer:
      '<strong>1 - Assinatura Essencial:</strong> conta com cursos completos em vídeo e/ou PDF, resumos direcionados, marcações digitais, caderno de anotações, tamanho de fonte personalizável, tira-dúvidas direto com o professor e sistema de questões.<br /><br /> <strong>2 - Assinatura Vitalícia:</strong> conta com cursos completos em vídeo e/ou PDF, resumos direcionados, marcações digitais, caderno de anotações, tamanho de fonte personalizável, tira-dúvidas direto com o professor, sistema de questões, Turma dos Feras pelo prazo de 24 meses, benefícios exclusivos para eventos presenciais, descontos exclusivos para consultorias individuais e acesso vitalício à plataforma (consulte os Termos de Uso - Direção Concursos).<br /><br /> <strong>3 - Assinatura Vitalícia Premium:</strong> conta com cursos completos em vídeo e/ou PDF, resumos direcionados, marcações digitais, caderno de anotações, tamanho de fonte personalizável, tira-dúvidas direto com o professor, sistema de questões, Turma dos Feras pelo prazo de 24 meses, benefícios exclusivos para eventos presenciais, descontos exclusivos para consultorias individuais, Sala VIP e acesso vitalício à plataforma (consulte os Termos de Uso - Direção Concursos).',
  },
  {
    icon: 'CalendarDays',
    category: 'platform',
    question: 'Qual o prazo de acesso?',
    answer:
      'Para os Cursos Completos, você terá acesso por até 3 meses após a realização da próxima prova que o curso se refere. Se você adquiriu um Módulo avulso, terá acesso por 12 meses (Caso a aplicação da prova objetiva do respectivo concurso aconteça antes do período de 12 meses da data de aquisição, o acesso aos Módulos ficará disponível por 3 (TRÊS) MESES após a data da prova.). Para a Assinatura Essencial, o prazo de acesso é de 12 meses. Os alunos das Assinaturas Vitalícia e Vitalícia Premium terão acesso ilimitado, desde que obedeçam aos critérios estabelecidos nos Termos de Uso - Direção Concursos.',
  },
  {
    icon: 'KeyRound',
    category: 'platform',
    question: 'Como acessar a área do aluno?',
    answer:
      "Para acessar a área do aluno, basta seguir estes passos simples: 1) Acesse o site do Direção Concursos: https://aluno.direcaoconcursos.com.br; 2) Insira o seu e-mail e senha que você cadastrou durante a compra; 3) Você será redirecionado para a sua área do aluno; 4) Clique no ícone do seu curso; 5) Se você possui uma assinatura Essencial, Vitalícia Premium ou Vitalícia, clique no ícone da assinatura ou em 'Assinaturas' no painel lateral esquerdo para acessar todos os conteúdos disponíveis. Depois disso, você já estará dentro da plataforma e poderá começar os seus estudos.",
  },
  {
    icon: 'TicketX',
    category: 'payment',
    question: 'Se não me sentir satisfeito, posso desistir da minha compra?',
    answer:
      "Claro, você tem a opção de solicitar o cancelamento e receber o reembolso integral do valor pago, desde que esteja dentro do prazo estabelecido nos Termos de Uso - Direção Concursos. Para os Cursos Completos, Módulo Avulso e Assinatura Essencial, é possível solicitar o cancelamento e o reembolso integral do valor pago em até 14 dias corridos após a aprovação do pagamento. Caso tenha optado pela Assinatura Vitalícia ou pela Assinatura Vitalícia Premium, o prazo para solicitar o cancelamento é de até 7 dias corridos após a aprovação do pagamento. Após esses prazos, não será possível realizar o cancelamento, estorno ou troca de cursos. Para solicitar o cancelamento, envie um e-mail dentro dos prazos mencionados para contato@direcaoconcursos.com.br com o assunto 'Cancelamento de compra'.",
  },
  {
    icon: 'Blocks',
    category: 'subscription',
    question: 'Quais cursos estão incluídos nas assinaturas do Direção?',
    answer:
      'Nas assinaturas Essencial, Vitalícia e Vitalícia Premium (respeitando as particularidades de cada plano), você terá acesso a todos os cursos completos produzidos pelo Direção, que abrangem mais de 350 concursos de diversas áreas (policial, fiscal, controle, tribunais, educação, entre outras). É importante ressaltar que os serviços individualizados, como correção de discursivas, recursos, mentorias e consultorias, não estão inclusos.',
  },
  {
    icon: 'CalendarCheck',
    category: 'content',
    question: 'Terei o curso atualizado quando o edital sair?',
    answer:
      'Sim. Nossos cursos são atualizados assim que o projeto básico é divulgado, a banca é selecionada e o edital é publicado. Todo o conteúdo é disponibilizado para que você possa estudar exatamente o que é cobrado. E o melhor de tudo, você não terá nenhum custo adicional para ter acesso às atualizações.',
  },
  {
    icon: 'Split',
    category: 'platform',
    question: 'Posso dividir meu acesso com um amigo(a)?',
    answer:
      'Não, o acesso às assinaturas e cursos do Direção é pessoal e exclusivo, sendo feito através do e-mail utilizado durante a compra. É ilegal distribuir, vender, compartilhar ou redistribuir de qualquer forma.',
  },
  {
    icon: 'LifeBuoy',
    category: 'content',
    question: 'Preciso de ajuda, qual o contato?',
    answer:
      "Fique à vontade para entrar em contato com a nossa equipe da Central de Atendimento ao Aluno do Direção Concursos. Você pode nos enviar um e-mail para contato@direcaoconcursos.com.br ou nos chamar pelo WhatsApp no número <a aria-label='Converse com a nossa equipe!' style='text-decoration: underline;' href='https://wa.me/5561983690055' target='_blank'>(61) 98369-0055</a>. Estamos disponíveis para ajudar de segunda a sexta, das 8h às 20h, e aos sábados, das 8h às 12h.",
  },
]

export const NOT_FOUND_SUGGESTION = [
  {
    icon: 'Rss',
    title: 'Notícias',
    description: 'Saiba tudo sobre o universo dos concursos públicos',
    href: '/noticias',
  },
  {
    icon: 'Radar',
    title: 'Concursos',
    description: 'Encontre concursos por todo o Brasil',
    href: '/concursos',
  },
  {
    icon: 'Shapes',
    title: 'Assinaturas',
    description: 'Saiba mais sobre nossos planos de assinatura',
    href: 'https://assinaturas.direcaoconcursos.com.br',
  },
  {
    icon: 'Trophy',
    title: 'Cursos',
    description: 'Conteúdo preparatório para acelerar sua aprovação',
    href: '/cursos',
  },
]

export const ALLOWED_ORIGINS = [
  /^http:\/\/localhost:4321$/,
  /^https:\/\/(?:[a-zA-Z0-9-]+\.)?direcaoconcursos\.com\.br$/,
]

export const NEWS_LIMIT = 6
export const ARTICLES_LIMIT = 6

export const GOOGLE_CLIENT_KEY =
  '830820641526-djkl0r9ncp7dqmnjmprjhs2f69rnqiue.apps.googleusercontent.com'

export const TOKEN_MARKUP = '<TOKEN>'

export const HEADER_INVALIDATE = {
  'Cache-Control':
    'no-store, no-cache, must-revalidate, proxy-revalidate, max-age=0',
  Pragma: 'no-cache',
  Expires: '0',
}
